import React from 'react';
import './PopupImage.less';


export const PopupImage = ({src}) => {
	return (
		<img className="image" src={src}/>
	);
};
